import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { ICON_COLOR, default as _Avatar } from '@scoir/avatar'
import { imageAsFullImageSrc } from '@scoir/avatar-image-url'
import cn from 'classnames'
import { get, head } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const useStyles = makeStyles(() => ({
  fallbackIcon: {
    fontSize: '12px',
  },
}))

/**
 * Customizes standard avatar component for current user
 * @param {object} props
 * @prop {string} name
 * @prop {string} avatarUrl
 * @prop {string} size
 * @returns Customized standard Avatar component
 */
const Avatar = ({ name, avatarUrl, size = 'xs' }) => {
  const classes = useStyles()
  return (
    <_Avatar
      size={size}
      sourceUrl={avatarUrl}
      fallbackIcon={head(name)}
      iconColor={ICON_COLOR.info}
      variant="circular"
      className={cn({ [classes.fallbackIcon]: size === 'xs' })}
    />
  )
}

Avatar.propTypes = {
  name: PropTypes.string,
  avatarUrl: PropTypes.string,
  size: PropTypes.string,
}

export default connect((store) => {
  const user = store.user.record
  const avatar = user.AvatarUrl
  return {
    name: get(user, 'Nickname', get(user, 'FirstName')),
    avatarUrl: avatar && imageAsFullImageSrc(avatar),
  }
})(Avatar)
